import React from "react";
import { View } from "react-native";
import color from "@constants/color";

export default function OverlayView(props) {
  const { style } = props || {};
  return (
    <View
      style={[
        {
          flex: 1,
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          opacity: 0.6,
          backgroundColor: color.lightGrayWhite,
          zIndex: 1000,
        },
        style,
      ]}
    />
  );
}
